import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setVisibleChat } from '../../actions/webim';
import { OurBenefitsSection } from '../../components/OurBenefitsSection';
import { RemoteFeaturesSection } from '../../components/RemoteFeaturesSection';
import { ScreenReaderOnly } from '../../components/ScreenReaderOnly';
import { CallToActionContainer } from '../CallToActionContainer';
import { CustomerRoleSectionContainer } from '../CustomerRoleSectionContainer';
import { DealStepsSectionContainer } from '../DealStepsSectionContainer';
import { FAQSectionContainer } from '../FAQSectionContainer';
import { HeroSectionContainer } from '../HeroSectionContainer';
import { PaymentMethodsContainer } from '../PaymentMethodsContainer';
import { PricingSectionContainer } from '../PricingSectionContainer';
import { WebimChatContainer } from '../WebimChatContainer';
import { trackSectionShown } from './tracking';
import { ConsultationRequestModalContainer } from '../ConsultationRequestModalContainer';

export const PageContainer: React.FC = () => {
  const dispatch = useDispatch();
  const onSectionViewed = (sectionName: string) => () => trackSectionShown(sectionName);
  const onDealStepsSectionViewed = () => {
    onSectionViewed('deal_process')();
    dispatch(setVisibleChat(true));
  };

  return (
    <>
      <ScreenReaderOnly>
        <h1>Циан.Сделка - электронная сделка купли продажи недвижимости</h1>
      </ScreenReaderOnly>

      <HeroSectionContainer />

      <CustomerRoleSectionContainer />

      <ActionAfterViewed callback={onDealStepsSectionViewed}>
        <DealStepsSectionContainer />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('deal_benefits')}>
        <OurBenefitsSection />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('deal_place')}>
        <RemoteFeaturesSection />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('deal_price')}>
        <PricingSectionContainer />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('services')}>
        <PaymentMethodsContainer />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('why_rieltor')}>
        <CallToActionContainer />
      </ActionAfterViewed>

      <ActionAfterViewed callback={onSectionViewed('FAQ')}>
        <FAQSectionContainer />
      </ActionAfterViewed>

      <ConsultationRequestModalContainer />

      <WebimChatContainer />
    </>
  );
};
